export default __webpack_public_path__ + "static/media/news-13.9b6ce0ea.jpg";